import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

export const LoadingText = styled.div`
  font-size: ${({ theme }) => theme.font.size.large};
`;

export const ErrorAlert = styled.div`
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  background-color: rgba(220, 38, 38, 0.1);
  color: ${({ theme }) => theme.color.errorIcon};
  font-size: ${({ theme }) => theme.font.size.small};
`;

export const ErrorHelpText = styled.p`
  font-size: ${({ theme }) => theme.font.size.small};
  color: ${({ theme }) => theme.color.betaBadge};
  margin-bottom: 1rem;
`;

